import { observer } from 'mobx-react-lite'
import { CollapseWithIcon, Switch } from 'shared/ui'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import type { IntegrationCollapseSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/store/IntegrationCollapseSettingsStore'

import sharedStyles from 'pages/settings/pages/integrations/pages/integrationSettings/ui/styles.module.scss'
import styles from './styles.module.scss'

type ICollapseIntegrationSettingsTimelineProps = {
  collapseStore: IntegrationCollapseSettingsStore
  dailyBundles: boolean
  name: string
  labelPart?: string
  children?: React.ReactNode
  onDailyBundlesToggle: () => void
}

export const CollapseIntegrationSettingsTimeline = observer(
  ({
    collapseStore,
    dailyBundles,
    name,
    labelPart = 'message',
    children,
    onDailyBundlesToggle,
  }: ICollapseIntegrationSettingsTimelineProps) => {
    return (
      <CollapseWithIcon
        className={styles.withoutBorder}
        opened={collapseStore.opened('timeline')}
        onClick={collapseStore.onToggle('timeline')}
        icon={'listLayout'}
        title={'Timeline events'}
        label={`Track every interaction directly in the activity feed in ${name}`}
        headerClassName={sharedStyles.collapseWithIcon}
      >
        <TitledRow
          title={`Log activities in ${name}`}
          label={`Create activity in ${name} for every ${labelPart}`}
          tooltip={`Enable this option to log each activity as a separate timeline event in ${name}.`}
        >
          <Switch size='middle' value={dailyBundles} onChange={onDailyBundlesToggle} />
        </TitledRow>
        {children}
      </CollapseWithIcon>
    )
  }
)
